import { useState } from 'react';
import { ChevronsUpDown } from 'lucide-react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList
} from '@/components/ui/command';
import { useLocations } from '@/data/location'; // Assuming you have a hook to fetch locations

const SelectLocation = ({
  value,
  onChange,
  disabled,
  regionId,
  activityId
}) => {
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const locations = useLocations({ regionId, activityId }); // Fetch locations

  const handleSelect = (locationId) => {
    onChange(locationId);
    setIsSelectOpen(false);
  };

  let selectedLocation = null;
  if (value) {
    selectedLocation = locations.data?.find((l) => l.id === value);
  }

  return (
    <Popover open={isSelectOpen} onOpenChange={setIsSelectOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          className={`w-full justify-between ${
            !value && 'text-muted-foreground'
          }`}
          disabled={disabled}
        >
          <div className="truncate">
            {selectedLocation ? selectedLocation.name : 'Select a location'}
          </div>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[300px] p-0" style={{ zIndex: 1001 }}>
        <Command>
          <CommandInput placeholder="Search locations..." />
          <CommandEmpty>No locations found.</CommandEmpty>
          <CommandGroup>
            <CommandList>
              {locations.data?.map((location) => {
                return (
                  <CommandItem
                    key={location.id}
                    onSelect={() => handleSelect(location.id)}
                  >
                    <div className="flex-auto truncate text-left pr-4">
                      {location.name}
                    </div>
                  </CommandItem>
                );
              })}
            </CommandList>
          </CommandGroup>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default SelectLocation;
